<template>
    <button
        :class="['a-ar-button', questionMarkCssClass]"
        type="button"
        @click="handleClick"
    />
</template>

<script>
import { computed } from '@vue/composition-api';

import { Storage } from '../../../utils/services/storage-service';

export default {
    name: "AArButton",
    setup(props, { emit }) {
        function handleClick() {
            emit('onClick');
        }
        
        const questionMarkCssClass = computed(() => {
            const isMotionEventsPermissionsDenied = Storage.local.get('motionEventsPermissions') === 'denied';
           
            return isMotionEventsPermissionsDenied ? 'question-mark' : null;
        });
        
        return {
            questionMarkCssClass,
            handleClick
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
